import Folder from '../store/schema/Folder';
import getMailboxFolderTreeDataTable from './getMailboxFolderTreeDataTable';

/**
 * Selector for a particular mailbox folder tree root folder
 * @param folderTreeIdentifier
 */
export default function getRootFolderForFolderTree(folderTreeIdentifier: string): Folder {
    const mailboxFolderTreeDataTable = getMailboxFolderTreeDataTable();
    const folderTreeData =
        mailboxFolderTreeDataTable && mailboxFolderTreeDataTable.get(folderTreeIdentifier);
    return folderTreeData?.rootFolder;
}
